export default __webpack_public_path__ + "static/media/Settings.936b3fa6.svg";